import * as React from "react";

import "./opacity-selector.scss";

import {cs} from "@Common/react/chain-services";

import {Slider1} from "./slider-1/slider-1";

export const OpacitySelector = ({state}) => cs(
    ["slider", (_, next) => Slider1({
        state,
        next,
    })],
    ({slider}) => (
        <div className="opacity-selector opacity-selector-2oe">
            <div className="top">
                <div {...{
                    className: "label",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Opacity",
                }}>
                    Opacity
                </div>
                <div {...{
                    className: "value",
                    "xd-qa-type": "text",
                    "xd-qa-name": "Opacity amount",
                }}>
                    {Math.round(slider.value * 100) + "%"}
                </div>
            </div>

            {slider.render({
                // direction: "vertical",
                // height: 200,
                // direction: "horizontal",
            })}
        </div>
    )
);
